<div class="dropdown-container">
  <mat-form-field
    class="font-face-properties"
    [appearance]="'standard'"
    [intercomTarget]="'toolbar-context-menu-font-family'"
  >
    <mat-select [value]="fontFace" (selectionChange)="fontFaceChanged.emit($event.value)">
      <mat-option *ngFor="let font of fontFamilyList || defaultFontList; trackBy: trackByValue" [value]="font">
        <span [ngStyle]="{ 'font-family': font + ', sans-serif' }">{{ font }}</span>
      </mat-option>
    </mat-select>
    <fa-icon matSuffix [icon]="['fas', 'chevron-down']" size="sm"></fa-icon>
  </mat-form-field>
</div>
